<template>
  <v-container fill-height :align-start="$vuetify.breakpoint.smAndDown">
    <v-row align-content="start" align-content-md="center" justify="center">
      <v-col cols="12" xs="12" md="8">
        <v-row cols="12">
          <v-col cols="12" xs="12" lg="6">
            <ChangeEmailCard />
          </v-col>
          <v-col cols="12" xs="12" lg="6">
            <ChangePasswordCard />
            <br />
            <RecoveryDownloadCard />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChangeEmailCard from "@/components/Account/ChangeEmailCard";
import ChangePasswordCard from "@/components/Account/ChangePasswordCard";
import RecoveryDownloadCard from "@/components/Account/RecoveryDownloadCard";

export default {
  components: {
    ChangeEmailCard,
    ChangePasswordCard,
    RecoveryDownloadCard,
  }
};
</script>
